var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkInclineOutline28(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.69 6.091a5.036 5.036 0 017.12 7.12l-.009.01-2.571 2.571a5.035 5.035 0 01-7.594-.543.75.75 0 011.2-.899 3.536 3.536 0 005.333.382l2.566-2.567a3.536 3.536 0 00-5-4.998l-1.47 1.461a.75.75 0 01-1.057-1.063L14.69 6.09z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.473 10.935a5.035 5.035 0 015.793 1.702.75.75 0 11-1.201.898 3.535 3.535 0 00-5.332-.382L7.166 15.72a3.536 3.536 0 005 5l1.46-1.462a.75.75 0 111.06 1.061l-1.474 1.475a5.036 5.036 0 01-7.12-7.12l.008-.01 2.572-2.571a5.035 5.035 0 011.801-1.158z"
  })));
}
export default SvgLinkInclineOutline28;